import { render, staticRenderFns } from "./AuthenticationIndex.vue?vue&type=template&id=80972924&scoped=true"
import script from "./AuthenticationIndex.vue?vue&type=script&lang=ts"
export * from "./AuthenticationIndex.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticationIndex.vue?vue&type=style&index=0&id=80972924&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80972924",
  null
  
)

export default component.exports